<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='row'>
  <div class='col-12 m-none full-height p-xs attachment-list w-100'>
    <div class='row'>
      <ng-container *ngFor='let attachment of attachments; let i = index; let first = first; let last = last;'>
        <well-attachment-list-item [attachment]='attachment'
                                   [canDelete]='canDelete'
                                   [canSync]='canSync'
                                   (delete)='onDelete($event)'
                                   (sync)='onSync($event)'
        >
        </well-attachment-list-item>
      </ng-container>
    </div>
  </div>
</div>


